import React, { Fragment, useState, useEffect } from 'react';
import { Container, TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, CardFooter } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import classnames from 'classnames';
import { toast } from 'react-toastify';
import { Send } from 'react-feather';
import { fetchFormData, fetchTableData, handleAddModifyOperation } from '../../../../Api/ApiMethods';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import PowerOfAttorneyInfo from './PowerOfAttorneyInfo';
import CustomerInfo from './CustomerInfo';
import ExpenseAndCollectionInfo from './ExpenseAndCollectionInfo';
import AccidentFileInfo from './AccidentFileInfo';
import CompensationInfo from './CompensationInfo';
import LicensePlateInfo from './LicensePlateInfo';
import AccidentsInfo from './AccidentsInfo';
import { apiClient } from '../../../../Api/client';
import { NAME_TR_REGEX, normalizeFieldValue, validateEmail, validateIban, validatePhoneTr, validateTcid } from '../../../../_helper/regexHandler';

const UserDetailForm = () => {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const isNew = location.state?.isNew || false;

    const [activeTab, setActiveTab] = useState('1');
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [powersOfAttorney, setPowersOfAttorney] = useState([]);
    const [insuranceCompanies, setInsuranceCompanies] = useState([]);
    const [licensePlates, setLicensePlates] = useState([]);
    const [accidentFiles, setAccidentFiles] = useState([]);
    const [expenses, setExpenses] = useState([]);
    const [paymentCollections, setPaymentCollections] = useState([]);
    const [finalCompensations, setFinalCompensations] = useState([]);
    const [customerAccidents, setCustomerAccidents] = useState([]);
    const [cities, setCities] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedAccidentFiles, setSelectedAccidentFiles] = useState([]);
    const [selectedPowersOfAttorney, setSelectedPowersOfAttorney] = useState([]);
    const [, setSelectedLicensePlates] = useState([]);
    const [isLoadingPowersOfAttorney, setIsLoadingPowersOfAttorney] = useState(false);
    const [isLoadingLicensePlates, setIsLoadingLicensePlates] = useState(false);
    const [isLoadingAccidentFiles, setIsLoadingAccidentFiles] = useState(false);
    const [isLoadingExpenses, setIsLoadingExpenses] = useState(false);
    const [isLoadingPaymentCollections, setIsLoadingPaymentCollections] = useState(false);
    const [isLoadingFinalCompensations, setIsLoadingFinalCompensations] = useState(false);
    const [isLoadingCustomerAccidents, setIsLoadingCustomerAccidents] = useState(false);
    
    const customerDetailApiUrl = `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/customer/${id}`;
    const licensePlateApiUrl = `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/licenseplate?customer=${id}`;
    const accidentFileApiUrl = `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/accidentfile?customer=${id}`;
    const expenseApiUrl = `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/expense?customer=${id}`;
    const paymentCollectionApiUrl = `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/paymentcollection?customer=${id}`;
    const finalCompensationApiUrl = `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/FinalCompensation`;
    const accidentApiUrl = `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/Accident`;
    const cityApiUrl = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/city';
    const districtApiUrl = `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/district?city=${selectedCity}`;
    const powerOfAttorneyApiUrl = `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/powerofattorney?customer=${id}`;
    const insuranceCompaniesApiUrl = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/insurancecompany';

    const toggle = tab => {
        if (activeTab !== tab) {
            setSelectedAccidentFiles([]);
            setSelectedPowersOfAttorney([]);
            setSelectedLicensePlates([]);
            if (tab === '2') {
                setIsLoadingPowersOfAttorney(true);
                setPowersOfAttorney([]);
            } else if (tab === '3') {
                setIsLoadingLicensePlates(true);
                setLicensePlates([]);
            } else if (tab === '4') {
                setIsLoadingAccidentFiles(true);
                setAccidentFiles([]);
            } else if (tab === '5') {
                setIsLoadingExpenses(true);
                setIsLoadingPaymentCollections(true);
                setExpenses([]);
                setPaymentCollections([]);
            } else if (tab === '6') {
                setIsLoadingFinalCompensations(true);
                setFinalCompensations([]);
            } else if (tab === '7') {
                setIsLoadingCustomerAccidents(true);
                setCustomerAccidents([]);
            }
            setActiveTab(tab);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchFormData({
                    apiEndpoint: customerDetailApiUrl,
                    page: 1,
                    pageSize: 1,
                });
                
                console.log('Customer API Response:', response);
                
                // Extract data based on API response structure
                let data;
                if (response?.isSuccess && response?.data) {
                    // New API format with isSuccess/data wrapper
                    data = response.data;
                } else if (response) {
                    // Old API format with direct data return
                    data = response;
                } else {
                    // No valid data
                    toast.error('Müşteri bilgileri alınamadı');
                    return;
                }
                
                if (data) {
                    // Safely access district and city properties
                    if (data.district?.city?.id) {
                        setSelectedCity(data.district.city.id);                        
                        try {
                            const districtsResponse = await fetchFormData({
                                apiEndpoint: `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/district?city=${data.district.city.id}`,
                                page: 1,
                                pageSize: 100
                            });
                            
                            // Handle both API response formats
                            let districtsData;
                            if (districtsResponse?.isSuccess && districtsResponse?.data) {
                                districtsData = districtsResponse.data;
                            } else {
                                districtsData = districtsResponse;
                            }
                            
                            if (districtsData?.items && Array.isArray(districtsData.items)) {
                                setDistricts(districtsData.items);
                            } else if (Array.isArray(districtsData)) {
                                setDistricts(districtsData);
                            }
                        } catch (error) {
                            console.error('Error fetching districts:', error);
                            toast.error('İlçeler alınırken hata oluştu.');
                        }
                    }

                    // Create formData with safe property access using optional chaining
                    const formData = {
                        customerType: data?.customerType || '',
                        reference: data?.reference || '', // Reference eklendi
                        agent: data?.agent || null, // Pass the entire agent object
                        agentName: data?.agent ? `${data.agent.firstName || ''} ${data.agent.lastName || ''}` : '',
                        clientName: data?.clientName || '',
                        companyName: data?.companyName || '',
                        identityNumber: data?.identityNumber || '',
                        taxNumber: data?.taxNumber || '',
                        crsNumber: data?.crsNumber || '',
                        contractRate: data?.contractRate?.toString() || '',
                        enforcementAttorneyFeeShareRate: data?.enforcementAttorneyFeeShareRate?.toString() || '',
                        judgmentAttorneyFeeShareRate: data?.judgmentAttorneyFeeShareRate?.toString() || '',
                        payInterestToCustomer: data?.payInterestToCustomer ?? false,
                        companyRepresentative: data?.companyRepresentative || '',
                        
                        // Safely access array elements with optional chaining
                        emailDescription: data?.emails && data.emails.length > 0
                            ? data.emails[0].emailDescription
                            : '',
                        email: data?.emails && data.emails.length > 0
                            ? data.emails[0].email
                            : '',
                        emailDescription2: data?.emails && data.emails.length > 1
                            ? data.emails[1].emailDescription
                            : '',
                        email2: data?.emails && data.emails.length > 1
                            ? data.emails[1].email
                            : '',
                        
                        ibanDescription: (data?.ibans && data.ibans[0]?.ibanDescription) || '',
                        iban: (data?.ibans && data.ibans[0]?.iban) || '',
                        ibanDescription2: (data?.ibans && data.ibans[1]?.ibanDescription) || '',
                        iban2: (data?.ibans && data.ibans[1]?.iban) || '',
                        
                        middleman: data?.middleman || '',
                        middlemanIban: data?.middlemanIban || '',
                        middlemanContractRate: data?.middlemanContractRate?.toString() || '',
                        isMiddlemanContractBased: data?.isMiddlemanContractBased || false,
                        middlemanContractPrice: data?.middlemanContractPrice?.toString() || '',
                        
                        phoneDescription: (data?.phones && data.phones[0]?.phoneDescription) || '',
                        phoneNumber: (data?.phones && data.phones[0]?.phone) || '',
                        phoneDescription2: (data?.phones && data.phones[1]?.phoneDescription) || '',
                        phoneNumber2: (data?.phones && data.phones[1]?.phone) || '',
                        
                        contractOriginalArrived: data?.contractOriginalArrived || false,
                        district: data?.district?.id || '',
                        address: data?.address || '',
                        comment: (data?.comments && data.comments[0]?.comment) || '',
                        created: data?.created ? new Date(data.created).toISOString().slice(0, 16) : '',
                    };
                    setFormData(formData);
                }
            } catch (error) {
                console.error('Error fetching customer details:', error);
                toast.error('Müşteri ayrıntıları alınırken hata oluştu.');
            }
        };
        if (!isNew) {
            fetchData();
        } else {
            const currentUserId = localStorage.getItem('userId');
            const currentUserFullName = localStorage.getItem('userFullName') || '';
            if (currentUserId) {
                const nameParts = currentUserFullName.trim().split(/\s+/);
                const lastName = nameParts.length > 1 ? nameParts.pop() : '';
                const firstName = nameParts.join(' ');
                setFormData(prev => ({
                    ...prev,
                    agent: { id: currentUserId, firstName, lastName },
                }));
            }
        }
    }, [customerDetailApiUrl, isNew]);

    const fetchTabData = async () => {
        if (isNew || !id) return;
        const currentTab = activeTab;
        try {
            if (currentTab === '2') {
                setIsLoadingPowersOfAttorney(true);
                setPowersOfAttorney([]);
                await fetchTableData({
                    apiEndpoint: powerOfAttorneyApiUrl,
                    page: 1,
                    pageSize: 10,
                    setDataCallback: (response) => {
                        // Handle API response formats
                        if (response?.isSuccess && response?.data?.items) {
                            setPowersOfAttorney(response.data.items);
                        } else if (response?.items) {
                            setPowersOfAttorney(response.items);
                        } else if (Array.isArray(response)) {
                            setPowersOfAttorney(response);
                        } else {
                            setPowersOfAttorney([]);
                        }
                    },
                    setTotalRowsCallback: () => { }
                });
            } else if (currentTab === '3') {
                setIsLoadingLicensePlates(true);
                setLicensePlates([]);
                await fetchTableData({
                    apiEndpoint: licensePlateApiUrl,
                    page: 1,
                    pageSize: 100,
                    setDataCallback: (response) => {
                        // Handle API response formats
                        if (response?.isSuccess && response?.data?.items) {
                            setLicensePlates(response.data.items);
                        } else if (response?.items) {
                            setLicensePlates(response.items);
                        } else if (Array.isArray(response)) {
                            setLicensePlates(response);
                        } else {
                            setLicensePlates([]);
                        }
                    },
                    setTotalRowsCallback: () => { }
                });
                
                // Fetch insurance companies for license plate form
                try {
                    const data = await fetchFormData({
                        apiEndpoint: insuranceCompaniesApiUrl,
                        page: 1,
                        pageSize: 100
                    });
                    
                    if (data?.isSuccess && data?.data?.items) {
                        setInsuranceCompanies(data.data.items);
                    } else if (data?.items) {
                        setInsuranceCompanies(data.items); 
                    } else if (Array.isArray(data)) {
                        setInsuranceCompanies(data);
                    } else {
                        setInsuranceCompanies([]);
                    }
                } catch (error) {
                    console.error('Error fetching insurance companies:', error);
                    toast.error('Sigorta şirketleri alınırken hata oluştu.');
                }
            } else if (currentTab === '4') {
                setIsLoadingAccidentFiles(true);
                setAccidentFiles([]);
                await fetchTableData({
                    apiEndpoint: accidentFileApiUrl,
                    page: 1,
                    pageSize: 10,
                    setDataCallback: (response) => {
                        // Handle API response formats
                        if (response?.isSuccess && response?.data?.items) {
                            setAccidentFiles(response.data.items);
                        } else if (response?.items) {
                            setAccidentFiles(response.items);
                        } else if (Array.isArray(response)) {
                            setAccidentFiles(response);
                        } else {
                            setAccidentFiles([]);
                        }
                    },
                    setTotalRowsCallback: () => { }
                });
            } else if (currentTab === '5') {
                setIsLoadingExpenses(true);
                setIsLoadingPaymentCollections(true);
                setExpenses([]);
                setPaymentCollections([]);
                await fetchTableData({
                    apiEndpoint: expenseApiUrl,
                    page: 1,
                    pageSize: 10,
                    setDataCallback: (response) => {
                        // Handle API response formats
                        if (response?.isSuccess && response?.data?.items) {
                            setExpenses(response.data.items);
                        } else if (response?.items) {
                            setExpenses(response.items);
                        } else if (Array.isArray(response)) {
                            setExpenses(response);
                        } else {
                            setExpenses([]);
                        }
                    },
                    setTotalRowsCallback: () => { }
                });
                
                await fetchTableData({
                    apiEndpoint: paymentCollectionApiUrl,
                    page: 1,
                    pageSize: 10,
                    setDataCallback: (response) => {
                        // Handle API response formats
                        if (response?.isSuccess && response?.data?.items) {
                            setPaymentCollections(response.data.items);
                        } else if (response?.items) {
                            setPaymentCollections(response.items);
                        } else if (Array.isArray(response)) {
                            setPaymentCollections(response);
                        } else {
                            setPaymentCollections([]);
                        }
                    },
                    setTotalRowsCallback: () => { }
                });
            } else if (currentTab === '7') {
                setIsLoadingCustomerAccidents(true);
                setCustomerAccidents([]);
                await fetchTableData({
                    apiEndpoint: `${accidentApiUrl}?customer=${id}`,
                    page: 1,
                    pageSize: 100,
                    setDataCallback: (rows) => {
                        const list = Array.isArray(rows) ? rows : [];
                        setCustomerAccidents(list);
                    },
                    setTotalRowsCallback: () => { }
                });
            } else if (currentTab === '6') {
                setIsLoadingFinalCompensations(true);
                setFinalCompensations([]);
                const customerName = formData.clientName || formData.companyName;
                if (customerName) {
                    await fetchTableData({
                        apiEndpoint: `${finalCompensationApiUrl}?customer=${encodeURIComponent(customerName)}`,
                        page: 1,
                        pageSize: 100,
                        setDataCallback: (rows) => {
                            const list = Array.isArray(rows) ? rows : [];
                            setFinalCompensations(list);
                        },
                        setTotalRowsCallback: () => { }
                    });
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
            toast.error('İlgili veriler çekilirken hata oluştu.');
        } finally {
            if (currentTab === '2') {
                setIsLoadingPowersOfAttorney(false);
            } else if (currentTab === '3') {
                setIsLoadingLicensePlates(false);
            } else if (currentTab === '4') {
                setIsLoadingAccidentFiles(false);
            } else if (currentTab === '5') {
                setIsLoadingExpenses(false);
                setIsLoadingPaymentCollections(false);
            } else if (currentTab === '6') {
                setIsLoadingFinalCompensations(false);
            } else if (currentTab === '7') {
                setIsLoadingCustomerAccidents(false);
            }
        }
    };

    useEffect(() => {
        fetchTabData();
    }, [activeTab, id, isNew, licensePlateApiUrl, insuranceCompaniesApiUrl]);

    useEffect(() => {
        const fetchCities = async () => {
            try {
                const response = await fetchFormData({
                    apiEndpoint: cityApiUrl,
                    page: 1,
                    pageSize: 100
                });
                
                // Handle both API response formats
                if (response?.isSuccess && response?.data?.items) {
                    setCities(response.data.items);
                } else if (response?.items) {
                    setCities(response.items);
                } else if (Array.isArray(response)) {
                    setCities(response);
                } else {
                    setCities([]);
                }
            } catch (error) {
                console.error('Error fetching cities:', error);
                toast.error('Şehirler alınırken hata oluştu.');
            }
        };
        fetchCities();
    }, []);

    useEffect(() => {
        const fetchDistricts = async () => {
            if (selectedCity) {
                try {
                    const response = await fetchFormData({
                        apiEndpoint: districtApiUrl,
                        page: 1,
                        pageSize: 100
                    });
                    
                    // Handle both API response formats
                    if (response?.isSuccess && response?.data?.items) {
                        setDistricts(response.data.items);
                    } else if (response?.items) {
                        setDistricts(response.items);
                    } else if (Array.isArray(response)) {
                        setDistricts(response);
                    } else {
                        setDistricts([]);
                    }
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    toast.error('İlçeler alınırken hata oluştu.');
                }
            } else {
                setDistricts([]);
            }
        };
        fetchDistricts();
    }, [selectedCity, districtApiUrl]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        let processedValue = type === 'checkbox' ? checked : value;
        if (typeof processedValue === 'string') {
            processedValue = normalizeFieldValue(name, processedValue);
        }

        // Aracı Sözleşme Türü değişikliği için özel mantık
        let updatedFormData = {
            ...formData,
            [name]: processedValue,
        };

        // Aracı Sözleşme Türü seçimi değiştiğinde diğer alanı null yap
        if (name === 'isMiddlemanContractBased') {
            if (processedValue === true || processedValue === "true") {
                // Oran bazlı seçildiğinde fiyat alanını temizle
                updatedFormData.middlemanContractPrice = '';
            } else if (processedValue === false || processedValue === "false") {
                // Fiyat bazlı seçildiğinde oran alanını temizle
                updatedFormData.middlemanContractRate = '';
            }
        }

        setFormData(updatedFormData);

         // Hataları temizle (eğer varsa)
         if (errors[name]) {
             setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
         }
    };

    const handleCustomerTypeChange = (e) => {
        const newCustomerType = e.target.value;
        setFormData((prevFormData) => ({
            ...prevFormData,
            customerType: newCustomerType,
            clientName: newCustomerType === 'Bireysel' ? prevFormData.clientName : '',
            tcid: newCustomerType === 'Bireysel' ? prevFormData.tcid : '',
            companyName: newCustomerType === 'Kurumsal' ? prevFormData.companyName : '',
            crsNumber: newCustomerType === 'Kurumsal' ? prevFormData.crsNumber : '',
            taxNumber: newCustomerType === 'Kurumsal' ? prevFormData.taxNumber : '',
            companyRepresentative: newCustomerType === 'Kurumsal' ? prevFormData.companyRepresentative : '',
            email: newCustomerType === 'Kurumsal' ? prevFormData.email : '',
        }));
    };

    const handleSave = async () => {
        // Validate form before saving
        const validationErrors = validateForm(formData); // Hataları al
        // Hata varsa işlemi durdur
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors); // Hataları state'e set et (zaten validateForm içinde yapılıyor ama garanti olsun)
            toast.error('Lütfen formdaki hataları düzeltin.');
            return;
        }

        try {
            const agentId = formData.agent?.id || '';
            const districtId = formData.district || '';
            const payload = {
                customerType: formData.customerType,
                reference: formData.reference || '', // Reference string olarak eklendi
                // Create: string, Update: HashSet<string> (backend DTO'ları farklı)
                agent: isNew ? agentId : (agentId ? [agentId] : []),
                clientName: formData.clientName || '', // State'den al (zaten büyük harf)
                companyName: formData.companyName || '', // State'den al (zaten büyük harf)
                identityNumber: formData.identityNumber || '', // State'den al (zaten büyük harf)
                taxNumber: formData.taxNumber || '', // State'den al (zaten büyük harf)
                crsNumber: formData.crsNumber || '', // State'den al (zaten büyük harf)
                contractRate: formData.contractRate ? Number(formData.contractRate) : 0,
                enforcementAttorneyFeeShareRate: formData.enforcementAttorneyFeeShareRate ? Number(formData.enforcementAttorneyFeeShareRate) : null,
                judgmentAttorneyFeeShareRate: formData.judgmentAttorneyFeeShareRate ? Number(formData.judgmentAttorneyFeeShareRate) : null,
                payInterestToCustomer: formData.payInterestToCustomer === true,
                companyRepresentative: formData.companyRepresentative || '', // State'den al (zaten büyük harf)
                emails: [
                    // Email state'den alınıyor (zaten küçük harf), açıklama state'den alınıyor (zaten büyük harf)
                    formData.email ? {
                        emailDescription: formData.emailDescription || 'Birincil E-posta',
                        email: formData.email
                    } : null,
                    formData.email2 ? {
                        emailDescription: formData.emailDescription2 || 'İkincil E-posta',
                        email: formData.email2
                    } : null
                ].filter(Boolean), // null olanları filtrele
                ibans: [
                     // IBAN state'den alınıyor, açıklama state'den alınıyor (zaten büyük harf)
                    formData.iban ? { ibanDescription: formData.ibanDescription || '', iban: formData.iban } : null,
                    formData.iban2 ? { ibanDescription: formData.ibanDescription2 || '', iban: formData.iban2 } : null
                ].filter(Boolean),
                middleman: formData.middleman || '', // State'den al (zaten büyük harf)
                middlemanIban: formData.middlemanIban || '', // State'den al (zaten büyük harf)
                middlemanContractRate: (formData.isMiddlemanContractBased === true || formData.isMiddlemanContractBased === "true")
                    ? (formData.middlemanContractRate ? Number(formData.middlemanContractRate) : 0)
                    : null,
                isMiddlemanContractBased: formData.isMiddlemanContractBased || false,
                middlemanContractPrice: (formData.isMiddlemanContractBased === false || formData.isMiddlemanContractBased === "false") 
                    ? (formData.middlemanContractPrice || null) 
                    : null,
                phones: [
                    // Telefon state'den alınıyor, açıklama state'den alınıyor (zaten büyük harf)
                    formData.phoneNumber ? { phoneDescription: formData.phoneDescription || '', phone: formData.phoneNumber } : null,
                    formData.phoneNumber2 ? { phoneDescription: formData.phoneDescription2 || '', phone: formData.phoneNumber2 } : null
                ].filter(Boolean),
                contractOriginalArrived: formData.contractOriginalArrived || false,
                // Create: string, Update: HashSet<string> (backend DTO'ları farklı)
                district: isNew ? districtId : (districtId ? [districtId] : []),
                address: formData.address || '', // State'den al (zaten büyük harf)
                comments: formData.comment ? [{ commentType: null, comment: formData.comment }] : [] // State'den al (belki büyük harf)
            };


            // API çağrısı (isNew kontrolü ile)
            if (isNew) {
                const response = await apiClient.post('/customer', payload);
                if (response?.data?.isSuccess && response?.data?.data?.id) {
                    toast.success('Müşteri başarıyla oluşturuldu!');
                    navigate(`/customer/${response.data.data.id}`); // Yeni ID ile detay sayfasına yönlendir
                } else {
                     // Başarısız ama kontrollü hata durumu
                     toast.error(response?.data?.message || 'Müşteri oluşturulamadı.');
                }
            } else {
                // Mevcut müşteri güncelleme
                await handleAddModifyOperation({
                    apiEndpoint: process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/customer',
                    selectedItem: { id },
                    mode: 'modify',
                    data: payload,
                    refreshDataCallback: null, // Detay sayfasında tablo refresh'e gerek yok
                    componentName: 'Müşteri'
                });
                // Güncelleme sonrası toast mesajı handleAddModifyOperation içinde veriliyor olabilir,
                // veya burada ekstradan gösterilebilir.
                // toast.success('Müşteri başarıyla güncellendi!');
            }
        } catch (error) {
             // Genel API veya ağ hatası
            console.error("Müşteri kaydetme hatası:", error);
            toast.error('Müşteri kaydedilirken bir hata oluştu.');
        }
    };

    const handleAccidentFileRowSelection = (state) => {
        setSelectedAccidentFiles(state.selectedRows);
    };

    const validateForm = (formData) => {
        const newErrors = {};

        // Validate customer type specific fields
        if (formData.customerType === 'Bireysel') {
            if (!formData.clientName?.trim()) {
                newErrors.clientName = 'Müvekkil adı zorunludur';
            }
            // Büyük harf kontrolü kaldırıldı
            // else if (!/^[A-ZĞÜŞİÖÇ][a-zğüşıöçĞÜŞİÖÇ]+(?: [A-ZĞÜŞİÖÇ][a-zğüşıöçĞÜŞİÖÇ]+)+$/.test(formData.clientName)) {
            //     newErrors.clientName = 'Ad ve soyad büyük harfle başlamalı ve en az iki kelimeden oluşmalıdır';
            // }
            // İsteğe bağlı: Sadece harf ve boşluk kontrolü eklenebilir
              else if (!NAME_TR_REGEX.test(formData.clientName)) {
                 newErrors.clientName = 'Müvekkil adı sadece harf ve boşluk içermelidir.';
            }


            if (!formData.identityNumber?.trim()) {
                newErrors.identityNumber = 'TC Kimlik Numarası zorunludur';
            } else if (!validateTcid(formData.identityNumber)) {
                newErrors.identityNumber = 'TC Kimlik Numarası 11 haneli rakam olmalıdır';
            }
        } else if (formData.customerType === 'Kurumsal') {
            if (!formData.companyName?.trim()) {
                newErrors.companyName = 'Şirket adı zorunludur';
            }
            if (!formData.crsNumber?.trim()) {
                newErrors.crsNumber = 'MERSIS numarası zorunludur';
            }
            if (!formData.taxNumber?.trim()) {
                newErrors.taxNumber = 'Vergi numarası zorunludur';
            }
            if (!formData.companyRepresentative?.trim()) {
                newErrors.companyRepresentative = 'Firma yetkilisi zorunludur';
            }
             // E-posta kontrolü aşağıda ortak alanda yapılıyor
        }

        // Validate common required fields
        if (!formData.phoneDescription?.trim()) {
            newErrors.phoneDescription = 'Telefon açıklaması zorunludur';
        }
        if (!formData.phoneNumber?.trim()) {
            newErrors.phoneNumber = 'Telefon numarası zorunludur';
        } else if (!validatePhoneTr(formData.phoneNumber)) {
            newErrors.phoneNumber = 'Telefon numarası 05 ile başlamalı ve 11 haneli olmalıdır';
        }

        if (!formData.ibanDescription?.trim()) {
            newErrors.ibanDescription = 'İban açıklaması zorunludur';
        }
        if (!formData.iban?.trim()) {
            newErrors.iban = 'İban zorunludur';
        } else {
            const ibanValidation = validateIban(formData.iban);
            if (!ibanValidation.isValid) {
                newErrors.iban = ibanValidation.error || 'Geçerli bir IBAN formatı giriniz (örn: TR12...)';
            }
        }

        if (!selectedCity) { // selectedCity state'ini kontrol et
            newErrors.city = 'İl seçimi zorunludur';
        }
        if (!formData.district) { // formData.district'i kontrol et
            newErrors.district = 'İlçe seçimi zorunludur';
        }
        if (!formData.address?.trim()) {
            newErrors.address = 'Adres zorunludur';
        }

        // E-posta kontrolleri (Hem bireysel hem kurumsal için geçerli olabilir)
        if (formData.email && !formData.emailDescription?.trim()) {
            newErrors.emailDescription = 'E-mail açıklaması zorunludur';
        }
         if (formData.email && !validateEmail(formData.email)) {
             newErrors.email = 'Geçerli bir e-mail adresi giriniz';
         }


        if (formData.email2 && !formData.emailDescription2?.trim()) {
            newErrors.emailDescription2 = 'E-mail 2 açıklaması zorunludur';
        }
         if (formData.email2 && !validateEmail(formData.email2)) {
            newErrors.email2 = 'Geçerli bir e-mail 2 adresi giriniz';
        }

        // Kurumsal Müşteri için ek zorunluluklar
        if (formData.customerType === 'Kurumsal') {
             if (!formData.email?.trim()) { // Kurumsal için email zorunlu
                newErrors.email = 'E-mail zorunludur';
             }
             if (!formData.emailDescription?.trim()) { // Kurumsal için email açıklaması zorunlu
                newErrors.emailDescription = 'E-mail açıklaması zorunludur';
             }
        }


        setErrors(newErrors); // Hataları state'e ata
        return newErrors; // Hata nesnesini döndür
    };

    return (
        <Fragment>
            <Breadcrumbs parent='Müşteri Alanları' title={isNew ? 'Yeni Müşteri' : 'Müşteri Detayı'} />
            <Container fluid>
                <div className='edit-profile'>
                    <Card>
                        <Nav className='nav-primary nav-pills mb-4 mt-4 ms-4 d-flex gap-2'>
                            <NavItem>
                                <NavLink
                                    role="button"
                                    tabIndex="0"
                                    className={classnames({ active: activeTab === '1' })}
                                    onClick={() => { toggle('1'); }}
                                >
                                    Müşteri Bilgileri
                                </NavLink>
                            </NavItem>
                            {!isNew && (
                                <>
                                    <NavItem>
                                        <NavLink
                                            role="button"
                                            tabIndex="0"
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => { toggle('2'); }}
                                        >
                                            Vekaletnameler
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            role="button"
                                            tabIndex="0"
                                            className={classnames({ active: activeTab === '3' })}
                                            onClick={() => { toggle('3'); }}
                                        >
                                            Plakalar
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            role="button"
                                            tabIndex="0"
                                            className={classnames({ active: activeTab === '7' })}
                                            onClick={() => { toggle('7'); }}
                                        >
                                            Kazalar
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            role="button"
                                            tabIndex="0"
                                            className={classnames({ active: activeTab === '4' })}
                                            onClick={() => { toggle('4'); }}
                                        >
                                            Kaza Dosyaları
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            role="button"
                                            tabIndex="0"
                                            className={classnames({ active: activeTab === '5' })}
                                            onClick={() => { toggle('5'); }}
                                        >
                                            Masraflar ve Tahsilatlar
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            role="button"
                                            tabIndex="0"
                                            className={classnames({ active: activeTab === '6' })}
                                            onClick={() => { toggle('6'); }}
                                        >
                                            Kapaklar
                                        </NavLink>
                                    </NavItem>
                                </>
                            )}
                        </Nav>
                    </Card>
                    <Card>
                        <CardBody>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    <CustomerInfo
                                        customerId={id}
                                        formData={formData}
                                        errors={errors}
                                        setErrors={setErrors}
                                        handleInputChange={handleInputChange}
                                        handleCustomerTypeChange={handleCustomerTypeChange}
                                        cities={cities}
                                        districts={districts}
                                        selectedCity={selectedCity}
                                        setSelectedCity={setSelectedCity}
                                    />
                                </TabPane>
                                {!isNew && (
                                    <>
                                        <TabPane tabId="2">
                                            <PowerOfAttorneyInfo
                                                powersOfAttorney={powersOfAttorney}
                                                isLoading={isLoadingPowersOfAttorney}
                                                onDataChange={() => {
                                                    fetchTabData();
                                                    setSelectedPowersOfAttorney([]);
                                                }}
                                                customerId={id}
                                                selectedRows={selectedPowersOfAttorney}
                                                onSelectedRowsChange={(state) => setSelectedPowersOfAttorney(state.selectedRows)}
                                            />
                                        </TabPane>
                                        <TabPane tabId="3">
                                            <LicensePlateInfo
                                                licensePlates={licensePlates}
                                                insuranceCompanies={insuranceCompanies}
                                                isLoading={isLoadingLicensePlates}
                                                onDataChange={() => fetchTabData()}
                                                customerId={id}
                                            />
                                        </TabPane>
                                        <TabPane tabId="4">
                                            <AccidentFileInfo
                                                accidentFiles={accidentFiles}
                                                isLoading={isLoadingAccidentFiles}
                                                selectedRows={selectedAccidentFiles}
                                                onSelectedRowsChange={handleAccidentFileRowSelection}
                                            />
                                        </TabPane>
                                        <TabPane tabId="5">
                                            <ExpenseAndCollectionInfo
                                                expenses={expenses}
                                                paymentCollections={paymentCollections}
                                                isLoadingExpenses={isLoadingExpenses}
                                                isLoadingPaymentCollections={isLoadingPaymentCollections}
                                                onDataChange={() => fetchTabData()}
                                                customerId={id}
                                            />
                                        </TabPane>
                                        <TabPane tabId="6">
                                            <CompensationInfo
                                                finalCompensations={finalCompensations}
                                                isLoading={isLoadingFinalCompensations}
                                                onDataChange={() => fetchTabData()}
                                            />
                                        </TabPane>
                                        <TabPane tabId="7">
                                            <AccidentsInfo
                                                accidents={customerAccidents}
                                                isLoading={isLoadingCustomerAccidents}
                                            />
                                        </TabPane>
                                    </>
                                )}
                            </TabContent>
                        </CardBody>
                        {activeTab === '1' && (
                            <CardFooter>
                                <div className="d-flex justify-content-end align-items-center w-100">
                                    <button className="btn btn-success d-flex align-items-center ms-2" onClick={handleSave}>
                                        <Send className="me-2" />
                                        {isNew ? 'Kaydet' : 'Güncelle'}
                                    </button>
                                </div>
                            </CardFooter>
                        )}
                    </Card>
                </div>
            </Container>
        </Fragment>
    );
};

export default UserDetailForm;
